import React from "react";
import Box from "../layout/Box";
import PlayerSeasonStatsTable from "./PlayerSeasonStatsTable";

export default function PlayerSeasonStats({
  onClickAdd,
  onClickDrop,
  onClickTrade,
}) {
  return (
    <Box title={"Player Stats"} centerContent={false}>
      <PlayerSeasonStatsTable
        onClickAdd={onClickAdd}
        onClickDrop={onClickDrop}
        onClickTrade={onClickTrade}
      />
    </Box>
  );
}
